import { DECORATIONS, decorationById } from "@zend/content";
import { GameIcon } from "../../assets/gameIcons.js";
import { pick, useT } from "../../i18n/index.js";
import { useBalances } from "../../state/balances.js";
import { Button } from "../../ui/Button.js";
import { Icon } from "../../ui/Icon.js";
import { useBase } from "../state.js";
import { Sheet } from "./shared.js";
import "../decorations.css";

/** Decorate: the owned decoration items with Place, the placed ones with Move and Store, and the garden purchase (D70). */
export function DecorationSheet() {
  const t = useT();
  const base = useBase((s) => s.base);
  const setPanel = useBase((s) => s.setPanel);
  const startDecorate = useBase((s) => s.startDecorate);
  const startMoveDecoration = useBase((s) => s.startMoveDecoration);
  const removeDecoration = useBase((s) => s.removeDecoration);
  const scr = useBalances((s) => s.balances?.SCR ?? 0);
  const loop = base?.loop;
  if (!base || !loop) return null;
  const stock = loop.decorationStock;
  const full = stock.placed >= stock.limit;
  const garden = decorationById("deco.garden");
  return (
    <Sheet title={<span className="row" style={{ gap: 8 }}><Icon name="edit" /> {t("base.decorate.title")}</span>} onClose={() => setPanel({ kind: "none" })} testId="decoration-sheet">
      <div className="deco-summary">
        <span className={`badge ${full ? "warn" : ""}`} data-testid="deco-placed">{t("base.decorate.placed", { n: stock.placed, max: stock.limit })}</span>
        <span className="hint">{t("base.decorate.hint")}</span>
      </div>

      <h3>{t("base.decorate.owned")}</h3>
      {stock.owned.length === 0 ? <p className="hint" data-testid="deco-none">{t("base.decorate.none")}</p> : null}
      <div className="deco-grid">
        {stock.owned.map((o) => {
          const def = decorationById(o.decoId);
          return (
            <div key={o.decoId} className="deco-card" data-testid={`deco-owned-${o.decoId}`}>
              <GameIcon id={def.model} size={56} />
              <div className="deco-copy">
                <strong>{pick(def.name)}</strong>
                <span className="hint">×{o.qty} · {def.footprint.w}×{def.footprint.h} · {t("base.decorate.morale", { n: def.morale })}</span>
              </div>
              <Button variant="primary" disabled={full} onClick={() => startDecorate(o.decoId)} data-testid={`deco-place-${o.decoId}`}>
                {t("base.decorate.place")}
              </Button>
            </div>
          );
        })}
        <div className="deco-card deco-garden" data-testid="deco-garden-card">
          <GameIcon id={garden.model} size={56} />
          <div className="deco-copy">
            <strong>{pick(garden.name)}</strong>
            <span className="hint">{t("colony.gardenHint")}</span>
          </div>
          <Button disabled={full || scr < loop.decorationOffer.costScr} onClick={() => startDecorate("deco.garden")} data-testid="deco-place-deco.garden">
            {t("colony.gardenAdd", { n: loop.decorationOffer.costScr })}
          </Button>
        </div>
      </div>

      <h3>{t("base.decorate.placedList")}</h3>
      {loop.decorations.length === 0 ? <p className="hint">{t("base.decorate.nothingPlaced")}</p> : null}
      {loop.decorations.map((d) => {
        const def = DECORATIONS.find((x) => x.id === d.decoId);
        return (
          <div key={d.id} className="row deco-row" data-testid={`deco-placed-${d.id}`}>
            <GameIcon id={d.modelId} size={32} />
            <span className="grow">
              <strong>{def ? pick(def.name) : d.decoId}</strong> <span className="mono dim">{d.x},{d.y}{d.rot ? ` · ${d.rot}°` : ""}</span>
            </span>
            <Button style={{ minHeight: 36 }} onClick={() => startMoveDecoration(d.id)} data-testid={`deco-move-${d.id}`}>
              <Icon name="move" /> {t("base.decorate.move")}
            </Button>
            <Button style={{ minHeight: 36 }} onClick={() => void removeDecoration(d.id)} data-testid={`deco-store-${d.id}`}>
              <Icon name="inventory" /> {d.decoId === "deco.garden" ? t("colony.removeGarden") : t("base.decorate.remove")}
            </Button>
          </div>
        );
      })}
    </Sheet>
  );
}
